import { IStore } from '..';
import { TConfigReducer } from '../../app/types/configType';

export const getConfig = (state: IStore): TConfigReducer => state.configReducer;
